module.exports = __webpack_public_path__ + "static/img/r2-1.e331ed1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/zh/r2-1.png
// module id = q3Ye
// module chunks = 1